module.exports={
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "Firehouse Alley",
        "district": "Pioneer Square",
        "intersection": "S of Yesler Way, W of First Ave.",
        "details": "According to the International Sustainability Institute, this alley has been used as a gathering space for music and film performances.  "
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.33484774827956,
            47.60171779088913
          ],
          [
            -122.3348343372345,
            47.601663534044214
          ],
          [
            -122.33485043048857,
            47.60089669795204
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Pioneer Passage Alley",
        "district": "Pioneer Square",
        "intersection": "S of Yesler Way, E of First Ave.",
        "details": "May undergo a renovation, following Nord Alley's design model. "
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.33352810144423,
            47.601719599449645
          ],
          [
            -122.33354151248932,
            47.60088222923847
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Kings Cross Alley",
        "district": "Pioneer Square",
        "intersection": "S of Jackson St., E of First Ave.",
        "details": "Has hosted a number of events, including during Alley Palooza in 2013.  "
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.3335388302803,
            47.59914957186013
          ],
          [
            -122.33355224132538,
            47.59831758654808
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Maynard Alley",
        "district": "Chinatown International District",
        "intersection": "S of King St., W of Seventh Ave.",
        "details": "Named after David Swinson Maynard, one of the founders of Seattle, this alley is home to a Chinese pet store."
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.32441127300261,
            47.59835195142073
          ],
          [
            -122.32442200183867,
            47.59752899695271
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Canton Alley",
        "district": "Chinatown Industrial District",
        "intersection": "S of King St., E of Seventh Ave. ",
        "details": "Located in one of the historic areas in the International District, Canton Alley holds events throughout the year, including during JamFest and Dragon Fest in July.  Supporters hope to renovate it in the near future.  "
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.32310235500336,
            47.598348334066785
          ],
          [
            -122.32311308383942,
            47.59752537954188
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Post Alley",
        "district": "Downtown Seattle",
        "intersection": "S of Virginia St., W of First Ave., all the way to just south of Columbia St.",
        "details": "Restaurants, bars and shops line this popular alley.  The southern leg, Post Alley Hooley, begins south of Pike Street, near the city's famous Gum Wall."
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.33552098274231,
            47.60299281054524
          ],
          [
            -122.33532786369324,
            47.6027830222129
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Post Alley",
        "district": "Downtown Seattle",
        "intersection": "S of Virginia St., W of First Ave., all the way to just south of Columbia St.",
        "details": "Restaurants, bars and shops line this popular alley.  The southern leg, Post Alley Hooley, begins south of Pike Street, near the city's famous Gum Wall."
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.33619153499605,
            47.60372163760959
          ],
          [
            -122.33559608459473,
            47.60306695966836
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Post Alley",
        "district": "Downtown Seattle",
        "intersection": "S of Virginia St., W of First Ave., all the way to just south of Columbia St.",
        "details": "Restaurants, bars and shops line this popular alley.  The southern leg, Post Alley Hooley, begins south of Pike Street, near the city's famous Gum Wall."
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.3368728160858,
            47.60447396457353
          ],
          [
            -122.33745753765106,
            47.60513585867624
          ],
          [
            -122.3375004529953,
            47.605193728800735
          ],
          [
            -122.3380959033966,
            47.60586646429987
          ],
          [
            -122.33812808990479,
            47.605906249461654
          ],
          [
            -122.33891665935515,
            47.60676704827874
          ],
          [
            -122.3396462202072,
            47.607569965498364
          ],
          [
            -122.34035432338715,
            47.608347553759856
          ],
          [
            -122.34053134918211,
            47.60854646983031
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Post Alley",
        "district": "Downtown Seattle",
        "intersection": "S of Virginia St., W of First Ave., all the way to just south of Columbia St.",
        "details": "Restaurants, bars and shops line this popular alley.  The southern leg, Post Alley Hooley, begins south of Pike Street, near the city's famous Gum Wall."
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.34113216400145,
            47.60902386531287
          ],
          [
            -122.34108924865721,
            47.60912874706991
          ],
          [
            -122.3417490720749,
            47.6098520638053
          ],
          [
            -122.34175443649292,
            47.60997502665548
          ],
          [
            -122.34299361705779,
            47.61069833168687
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Unnamed 1",
        "district": "University District",
        "intersection": "S of 45th St., E of University Ave.",
        "details": "The University District Partnership has proposed renovating this alley.  "
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.31259346008301,
            47.66117475867834
          ],
          [
            -122.31258273124696,
            47.65988851189588
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Unnamed 2",
        "district": "University District",
        "intersection": "S of 43rd St., E of University Ave.S of 43rd St., E of University Ave.",
        "details": "Of all the U District alleys with renovation plans, this one is the furthest along.  Greenery, bike racks and the storefront of coffee shop Café Allegro occupy this space."
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.31258273124696,
            47.659657273158636
          ],
          [
            -122.31261491775511,
            47.65842880019403
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Unnamed 3",
        "district": "University District",
        "intersection": "S of 42nd St., E of University Ave.",
        "details": "The University District Partnership has proposed renovating this alley.  "
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.31259346008301,
            47.65816864926929
          ],
          [
            -122.31263637542725,
            47.6569329146751
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Alley 24",
        "district": "South Lake Union",
        "intersection": "S of Thomas St., E of Pontius Ave. - goes E to W",
        "details": "This alley runs in between the Alley 24 apartment complex.  A fitness center and the Espresso Vivace coffee shop have entrances that open onto it."
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.33168005943298,
            47.62029925816445
          ],
          [
            -122.33048379421234,
            47.62029925816445
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Chophouse Row Mews",
        "district": "Capitol Hill",
        "intersection": "S of Pike St., E of 11th Ave. - goes E to W",
        "details": "This manmade alley splits the Chophouse Row buildings into two sections."
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.31808930635451,
            47.613595068078915
          ],
          [
            -122.31755018234253,
            47.61359145177895
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "South Post Alley",
        "district": "Pioneer Square",
        "intersection": "S of Main St., W of First Ave.",
        "details": "This is one of the activated alleys in Pioneer Square."
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.33483701944351,
            47.60004122838739
          ],
          [
            -122.33484774827956,
            47.599276177160846
          ],
          [
            -122.33485847711562,
            47.599240004249054
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Nord Alley",
        "district": "Pioneer Square",
        "intersection": "S of Main St., E of First Ave.",
        "details": "Renovations that started in 2008 include lighting fixtures and art panels.  And the Back Alley Bike Repair shop has moved in. Will be repaved as early as winter 2015.  "
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [
            -122.33352541923522,
            47.600033993912795
          ],
          [
            -122.33354687690735,
            47.599276177160846
          ]
        ]
      }
    }
  ]
}